<template>
  <div>
    <!-- START NAV -->
    <nav class="navbar is-white">
      <div class="container">
        <div class="navbar-brand">
          <img src="../../assets/img/logo.png" alt="carquidiocesanos" style="padding: 2px; height: 100px !important;">
          <div class="navbar-burger burger" data-target="navMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div id="navMenu" class="navbar-menu">
          <div class="navbar-start">
          </div>
          <div class="navbar-end">
            <a class="navbar-item has-text-danger" @click="goTo('logout')">Salir</a>
          </div>
        </div>
      </div>
    </nav>
    <!-- END NAV -->
    <div class="container">
      <div class="columns">
        <div class="column is-3">
          <aside class="menu is-hidden-mobile">
            <p class="menu-label" v-if="$session.get('user').admin == 1">
              General
            </p>
            <ul class="menu-list">
              <li v-if="$session.get('user').admin == 1"><a :class="(view == 'dashboard-view') ? 'is-active' : ''" @click="goTo('home')">Home</a></li>
              <li v-if="$session.get('user').admin == 1"><a :class="(view == 'accounts-view') ? 'is-active' : ''" @click="goTo('account')">Cuenta</a></li>
              <li v-if="$session.get('user').admin == 1"><a :class="(view == 'users-view') ? 'is-active' : ''" @click="goTo('user')">Usuario</a></li>
            </ul>
            <p v-if="$session.get('user').admin == 1 || $session.get('user').transaction" class="menu-label">
              Proveedor
            </p>
            <ul v-if="$session.get('user').admin == 1 || $session.get('user').transaction" class="menu-list">
              <li v-if="$session.get('user').admin == 1 "><a :class="(view == 'input-view') ? 'is-active' : ''" @click="goTo('input')">Cargar archivo</a></li>
              <li><a :class="(view == 'output-view') ? 'is-active' : ''" @click="goTo('output')">Exportar pdf</a></li>
              <li v-if="$session.get('user').admin == 1"><a :class="(view == 'output-excel') ? 'is-active' : ''" @click="goTo('output/excel')">Exportar excel</a></li>
            </ul>
            <p v-if="$session.get('user').admin == 1 || $session.get('user').transactionEducational" class="menu-label">
              Responsable Financiero
            </p>
            <ul v-if="$session.get('user').admin == 1 || $session.get('user').transactionEducational" class="menu-list">
              <li v-if="$session.get('user').admin == 1 "><a :class="(view == 'input-students-view') ? 'is-active' : ''" @click="goTo('input-students')">Cargar archivo</a></li>
              <li><a :class="(view == 'output-educational-view') ? 'is-active' : ''" @click="goTo('output-educational')">Exportar pdf</a></li>
            </ul>
            <p class="menu-label" v-if="$session.get('user').admin == 1">
              Configuracion
            </p>
            <ul class="menu-list">
              <li v-if="$session.get('user').admin == 1"><a :class="(view == 'password-view') ? 'is-active' : ''" @click="goTo('changepassword')">Cambiar contraseña</a></li>
            </ul>
          </aside>
        </div>
        <div class="column is-9">
          <dashboard    v-if      ="this.view == 'dashboard-view'"></dashboard>
          <accounts     v-else-if ="this.view == 'accounts-view'"></accounts>
          <account-form v-else-if ="this.view == 'account-form'"></account-form>
          <users     v-else-if ="this.view == 'users-view'"></users>
          <user-form v-else-if ="this.view == 'user-form'"></user-form>
          <input-upload     v-else-if ="this.view == 'input-view'"></input-upload>
          <input-students-upload     v-else-if ="this.view == 'input-students-view'"></input-students-upload>
          <output-list    v-else-if ="this.view == 'output-view'"></output-list>
          <output-excel    v-else-if ="this.view == 'output-excel'"></output-excel>
          <output-educational-list    v-else-if ="this.view == 'output-educational-view'"></output-educational-list>
          <change-password     v-else-if ="this.view == 'password-view'"></change-password>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/home.css'
import env from '@/env'
import Accounts from '../account/Accounts.vue'
import AccountForm from '../account/AccountForm.vue'
import Users from '../user/Users.vue'
import UserForm from '../user/UserForm.vue'
import ChangePassword from '../user/ChangePassword.vue'
import InputUpload from '../input/Input.vue'
import InputStudentsUpload from '../input/InputStudents.vue'
import OutputList from '../output/Output.vue'
import OutputExcel from '../output/OutputExcel.vue'
import OutputEducationalList from '../output/OutputEducational.vue'
import Dashboard from './Dashboard.vue'
// import PerformanceService from '@/services/performanceService'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'home',
  mixins: [xMisc, sGate],
  components: {
    env,
    Accounts,
    AccountForm,
    Users,
    UserForm,
    ChangePassword,
    InputUpload,
    OutputList,
    OutputExcel,
    OutputEducationalList,
    Dashboard,
    InputStudentsUpload
  },
  data () {
    return {
      envVars: env
    }
  },
  props: {
    view: {type: String, default: 'dashboard-view'}
  },
  watch: {
    '$route' (to, from) {
      this.start()
      // this.displayElement = to.name
      this.$Progress.finish()
    }
  },
  mounted () {
    this.$session.start()
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue